export { default as Link } from './Link';
export type { LinkProps } from './types';
